import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { TimezoneDatePipe } from '../../../../timezone-date.pipe';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { ContractCandidateService } from 'src/app/services/contract-candidate.service';
import { CONTRACT_ROLES } from '../company/company.service';
import Swal from 'sweetalert2';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-modal-popup',
  standalone: true,
  imports: [CommonModule, FormsModule, TimezoneDatePipe, NgSelectModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.scss','../../../../../styles/admin/style.scss','../../../../../styles/admin/app.scss']
})
export class ModalPopupComponent {
  @ViewChildren('networkTextarea') networkTextareas!: QueryList<ElementRef>;
  @Input() title : string;
  @Input() fields : Array<any>;

  // Contract roles editing (passed via initialState when SUPERADMIN views a paid-plan user)
  @Input() showContractRoles: boolean = false;
  @Input() user: any = null;
  @Input() businessId: string = '';

  readonly contractRolesList = CONTRACT_ROLES;
  selectedRoles: string[] = [];
  private originalRoles: string[] = [];
  saving = false;

  constructor(
    private modalService: BsModalService,
    private api: ApiService,
    private util: UtilService,
    private contractCandidateService: ContractCandidateService
  ) {}

  ngOnInit(): void {
    if (this.showContractRoles && this.user) {
      this.selectedRoles = [...(this.user?.contractRoles || [])];
      this.originalRoles = [...this.selectedRoles];
    }
  }

  get hasRoleChanges(): boolean {
    return JSON.stringify([...this.selectedRoles].sort()) !== JSON.stringify([...this.originalRoles].sort());
  }

  getRoleLabel(value: string): string {
    return this.contractRolesList.find(r => r.value === value)?.label || value;
  }

  saveContractRoles(): void {
    if (!this.hasRoleChanges) return;
    this.saving = true;
    this.util.startLoader();
    this.contractCandidateService.updateContractRoles(
      this.businessId,
      this.user?.userId || this.user?.id,
      this.selectedRoles
    ).subscribe({
      next: (res: any) => {
        this.saving = false;
        this.util.stopLoader();
        if (res.code === '00000') {
          this.user.contractRoles = [...this.selectedRoles];
          this.originalRoles = [...this.selectedRoles];
          Swal.fire({ icon: 'success', title: 'Contract roles updated', showConfirmButton: false, timer: 2000 });
        } else {
          Swal.fire('Error', res.message || 'Failed to update contract roles.', 'error');
        }
      },
      error: () => {
        this.saving = false;
        this.util.stopLoader();
        Swal.fire('Error', 'Failed to update contract roles. Please try again.', 'error');
      }
    });
  }


  closeModal(){
    this.modalService.hide(this.modalService.getModalsCount());
  }

  getListValue(data) : Array<string>{
    if(data){
      const arr = data.split(",");
      return arr;
    }
    return [];
  }
  ngAfterViewInit() {
    setTimeout(() => this.adjustTextareaHeight(), 0);
  }
  adjustTextareaHeight() {
    this.networkTextareas.forEach(textareaRef => {
      const textarea = textareaRef.nativeElement as HTMLTextAreaElement;
      textarea.style.height = 'auto'; // Reset height
      const formattedValues = this.getFormattedValues(textarea.value); // Get formatted values
      textarea.value = formattedValues; // Update value to formatted text
      textarea.style.height = `${textarea.scrollHeight}px`; // Set height based on scrollHeight
    });
  }

  getFormattedValues(values: string | string[]): string {
    if (Array.isArray(values)) {
      return values.join(',\n');
    } else if (typeof values === 'string') {
      return values.replace(/,\s*/g, ',\n');
    } else {
      console.warn('Expected a string or string[] but received:', values);
      return '';
    }
  }


}
